import { useEffect, useState } from 'react'

export const useProgressiveImage = (src: string) => {
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null)

  useEffect(() => {
    let isMounted = true
    setIsLoading(true)
    setHasError(false)

    const img = new Image()
    img.src = src

    img.onload = () => {
      if (isMounted) {
        setLoadedSrc(src)
        setIsLoading(false)
      }
    }

    img.onerror = () => {
      if (isMounted) {
        console.error('Image failed to load:', src)
        setHasError(true)
        setIsLoading(false)
      }
    }

    return () => {
      isMounted = false
    }
  }, [src])

  return {
    isLoading,
    hasError,
    loadedSrc,
  }
}
